export const MEDIQ_SELECT_INFO_URL = 'https://mediq.nl/mediq-select';

export const MEDIQ_SELECT_INFO_TEXT =
  'Mediq Select brengt zorgvuldig geselecteerde producten van betrouwbare kwaliteit samen onder één duidelijk herkenbaar label, zonder dat er iets inhoudelijk verandert.';
